import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCubes } from '@fortawesome/free-solid-svg-icons';

const Header = () => (
  <header>
    <FontAwesomeIcon icon={faCubes} /> Will Ashe - Tech Test
  </header>
);

export default Header;
